import { GestaoAmeiProps } from './props';

const themeKeys = [
  'highlightedColor',
  'foregroundColor',
  'backgroundColor',
  'titleColor',
  'textColor',
  'separatorColor',
  'filterAreaBackgroundColor',
  'headerBackgroundColor',
  'footerBackgroundColor',
  'cardBackgroundColor',
  'shadow',
];

// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() {}

export function validate(
  condition: boolean,
  what: string,
  message: string,
): void {
  if (condition) {
    throw Error(`💣
      [Gestão AMEI] informe o campo:
      ¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨
        ${what}

      ${message}
    `);
  }
}

export function validation({
  realm,
  module,
  roleMapOptions = {},
  roleMapEvents = {},
  events = {},
  height,
  width,
  theme = {},
}: Partial<GestaoAmeiProps>): void {
  validate(
    !['interno', 'externo'].includes(realm ?? ''),
    'realm: "externo" | "interno"',
    'Informe o realm correto.',
  );

  const isModuleRoleMap = module === 'role-map';

  // Module: role-map
  validate(
    !isModuleRoleMap,
    'module: "role-map"',
    'Somente o módulo "Perfis" está habilitado atualmente.',
  );

  if (isModuleRoleMap) {
    validate(
      typeof roleMapOptions?.clientId !== 'string',
      'roleMapOption.clientId: string',
      'Para carregar o componente.',
    );
    validate(
      'editUser' in roleMapOptions && 'usersSuggestion' in roleMapOptions,
      'roleMapOption.editUser: string, roleMapOption.userSuggestion: string | string[]',
      'Informe somente uma das duas opções (editUser ou userSuggestion).',
    );
    validate(
      typeof (roleMapOptions?.editUser ?? '') !== 'string',
      'roleMapOption.username: string',
      'Para carregar o componente com um usuário selecionado.',
    );
    validate(
      typeof (roleMapOptions?.usersSuggestion ?? '') !== 'string' &&
        !Array.isArray(roleMapOptions?.usersSuggestion),
      'roleMapOption.usersSuggestion: string | string[]',
      'Para carregar o componente com sugestões de usuário para cadastro. Podendo ser uma string ou um array de string com os usuários',
    );
    validate(
      typeof (roleMapOptions?.rolesSuggestion ?? '') !== 'string' &&
        !Array.isArray(roleMapOptions?.rolesSuggestion),
      'roleMapOption.rolesSuggestion: string | string[]',
      'Para carregar o componente com sugestões de roles. Podendo ser uma string representando a role ou um array com uma ou mais roles',
    );
    validate(
      typeof (roleMapEvents?.onSaveUserRoles ?? noop) !== 'function',
      `roleMapEvents.onSaveUserRoles(event: {
            username: string;
            roles: string[];
          }): void`,
      `Para sinalizar que um usuário teve a lista de roles salva. Quando enviada a
          lista de roles vazia, significa que deletou todas que tinha.`,
    );
  }
  // Module: ...

  validate(
    typeof height !== 'number' && typeof height !== 'string',
    'height: number | string',
    `Para ajustar o tamanho do componente. Caso informado um número, usa o valor
      com a unidade em pixels (px). Caso contrário usa o valor com a unidade
      informada no texto.`,
  );
  validate(
    typeof width !== 'number' && typeof width !== 'string',
    'width: number | string',
    `Para ajustar a largura do componente. Caso informado um número, usa o valor
      com a unidade em pixels (px). Caso contrário usa o valor com a unidade
      informada no texto.`,
  );
  validate(
    typeof (events?.onNotification ?? noop) !== 'function',
    `events.onNotification(event: {
          message: string;
          supportMessage?: string;
          icon?: string | false;
          color?: 'default' | 'destructive' | 'confirmation' | 'attention';
        }): void`,
    'Para receber as notificações emitidas de dentro do componente.',
  );

  Object.entries(theme)
    .filter(([key]) => themeKeys.includes(key))
    .forEach(([key, value]) =>
      validate(
        typeof value !== 'string',
        `theme.${key}: string`,
        `Para ajustar a propriedade "${key}" do tema do componente.`,
      ),
    );
}
